module.exports = __webpack_public_path__ + "img/top-0-1.1c7b024b.jpg";